import type React from 'react'
import { createContext, useMemo } from 'react'

import {
  DROGASIL_TOKENS,
  GLOBALS_TOKENS,
  PRIME_TOKENS,
  RAIA_TOKENS,
  RDSAUDESISTEMAS_TOKENS,
  SUBSCRIPTION_TOKENS,
  type Themes,
  rnFontFamily,
} from '@raiadrogasil/pulso-design-tokens'

type TThemeProviderProps = {
  theme: Themes
  children: React.ReactNode
}

type ColorsTokens =
  | typeof DROGASIL_TOKENS
  | typeof RAIA_TOKENS
  | typeof RDSAUDESISTEMAS_TOKENS
  | typeof SUBSCRIPTION_TOKENS
  | typeof PRIME_TOKENS

type BaseTokens = typeof GLOBALS_TOKENS

type DesignTokens = ColorsTokens &
  BaseTokens & {
    fontFamily: typeof rnFontFamily
  }

export const ThemeContext = createContext({} as DesignTokens)

export function ThemeProvider({ theme, children }: TThemeProviderProps) {
  const currentTheme = useMemo(() => {
    const mapThemes = {
      rdsaudesistemas: RDSAUDESISTEMAS_TOKENS,
      drogasil: DROGASIL_TOKENS,
      raia: RAIA_TOKENS,
      subscription: SUBSCRIPTION_TOKENS,
      prime: PRIME_TOKENS,
    } as const

    return {
      // @ts-ignore
      ...mapThemes[theme],
      fontFamily: {
        ...rnFontFamily,
      },
      ...GLOBALS_TOKENS,
    }
  }, [theme]) satisfies DesignTokens

  return (
    <ThemeContext.Provider value={currentTheme}>
      {children}
    </ThemeContext.Provider>
  )
}

export function withThemeProvider<T extends {}>(
  Component: React.ComponentType<T>,
  variant: Themes
) {
  return function ThemedComponent(componentProps: T) {
    return (
      <ThemeProvider theme={variant}>
        <Component {...componentProps} />
      </ThemeProvider>
    )
  }
}
